<template>
  <div>
    <div class="loading" v-if="loading">
      <md-progress-spinner class="md-accent" :md-diameter="100" :md-stroke="10" md-mode="indeterminate"></md-progress-spinner>
    </div>
    <div class="loading" v-if="!loading && errorMessage !== null">
      {{errorMessage}}
    </div>
    <div class="loading" v-if="!loading && errorMessage === null">

      <md-card>
        <md-card-header>
          <div class="md-title">Locations</div>
        </md-card-header>

        <md-card-content>
          <md-table>

            <md-table-row v-if="locationList && locationList.length > 0">
              <md-table-head md-sort-name="name">Name</md-table-head>
              <md-table-head>Abbreviation</md-table-head>
              <md-table-head>Capacity</md-table-head>
              <md-table-head>Enabled</md-table-head>
            </md-table-row>

            <!--<tr class="md-table-row" v-for="city in cities" :key="city.versionedId.id" v-on:click="editCity(city)">-->
            <md-table-row v-for="object in locationList" :key="object.versionedId.id" >
              <md-table-cell>
                <span v-if="!object.edit">{{object.name}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-focus v-model="object.name" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" maxlength="255"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.name}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!object.edit">{{object.abbreviation}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-model="object.abbreviation" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" maxlength="255"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.abbreviation}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <span v-if="!object.edit">{{object.capacity}}</span>
                <span v-if="object.edit">
                  <md-field>
                    <md-input v-model="object.capacity" @keyup.enter="saveObject(object)" @keyup.esc="cancelEditObject(object)" type="number"></md-input>
                    <md-icon style="color: red;" v-if="isSoftLocked(object.versionedId.id)"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                    <span class="md-helper-text">{{object.oldObject.capacity}}</span>
                  </md-field>
                </span>
              </md-table-cell>

              <md-table-cell>
                <md-checkbox v-model="object.enabled" :disabled="!object.edit" />
              </md-table-cell>

              <md-table-cell>
                <md-button class="md-icon-button md-dense md-primary editButton" @click="editObject(object)" v-if="!object.edit"  v-bind:disabled="object.saving">
                  <md-icon class="md-morph-final">edit</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="saveObject(object)" v-if="object.edit">
                  <md-icon class="md-morph-final">save</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="cancelEditObject(object)" v-if="object.edit">
                  <md-icon class="md-morph-final">cancel</md-icon>
                </md-button>
                <md-button class="md-icon-button md-dense md-primary" @click="askToDelete(object)" v-if="object.edit"  v-bind:disabled="object.saving">
                  <md-icon class="md-morph-final">delete</md-icon>
                  <!--<md-tooltip md-delay="100">Delete</md-tooltip>-->
                </md-button>
                <span>
                  <md-icon style="margin-top: 4px;" v-if="!object.edit && isSoftLocked(object.versionedId.id)" class="md-morph-final"><md-tooltip md-direction="bottom">{{getLockedByString(object.versionedId.id)}}</md-tooltip>warning</md-icon>
                </span>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>
        <md-card-actions>
          <md-button class="md-primary md-raised" @click="showNewObjectDialog">New Location</md-button>
        </md-card-actions>
      </md-card>

    </div>

    <md-dialog :md-active.sync="createPromptActive">
      <md-dialog-title>Create a new location</md-dialog-title>

      <div class="dialogContent">
        <md-field >
          <label>Name</label>
          <md-input v-focus ref="newObjectFirstField" v-model="newObject.name" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" maxlength="255"></md-input>
        </md-field>

        <md-field >
          <label>Abbreviation</label>
          <md-input v-model="newObject.abbreviation" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" maxlength="255"></md-input>
        </md-field>

        <md-field >
          <label>Capacity</label>
          <md-input v-model="newObject.capacity" @keyup.enter="createObject" @keyup.esc="createPromptActive = false" type="number"></md-input>
        </md-field>

        <md-dialog-actions>
          <md-button class="md-primary" @click="createPromptActive = false">Cancel</md-button>
          <md-button class="md-primary md-raised" @click="createObject" v-bind:disabled="!dialogCreateActive">Create</md-button>
        </md-dialog-actions>
      </div>
    </md-dialog>

    <md-dialog-confirm
      :md-active.sync="deletePromptActive"
      md-title="Delete Location"
      :md-content="'Are you sure you want to delete \'' + objectToDelete.name + '\'?'"
      md-confirm-text="Delete"
      md-cancel-text="Cancel"
      @md-confirm="confirmDelete" />

    <md-snackbar md-position="center" :md-duration="8000" :md-active.sync="showSnackbar" md-persistent>
      <span>{{snackbarMessage}}</span>
      <md-button class="md-accent" @click="showSnackbar = false">OK</md-button>
    </md-snackbar>
  </div>
</template>

<script>
    export default {
        name: "staff",
        data() {
            var mutableFields = ['name', 'capacity', 'abbreviation'];
            var newObject = {};
            mutableFields.forEach(fieldName => {
                newObject[fieldName] = '';
            });
            return {
                loading: false,
                changed: false,
                errorMessage: null,
                createPromptActive: false,
                deletePromptActive: false,
                objectToDelete: {},
                showSnackbar: false,
                snackbarMessage: '',
                newObject: newObject,
                mutableFields: mutableFields
            }
        },
        computed: {
            locationList() {
                if (this.$store.state.currentCityDetails) {
                    this.loading = false;
                    if (this.changed || !this.changed) {
                        this.changed = false;
                        return this.$store.state.currentCityDetails.rooms;
                    }
                } else {
                    return [];
                }
            },
            dialogCreateActive() {
                var active = true;
                this.mutableFields.forEach(fieldName => {
                    if (this.newObject[fieldName].length < 1) {
                        active = false;
                    }
                });
                return active;
            }
        },
        methods: {
            isSoftLocked(lockId) {
                return (this.$store.state.otherUserPageLocks[lockId] !== undefined)
            },
            getLockedByString(lockId) {
                if (this.$store.state.otherUserPageLocks[lockId] !== undefined) {
                    return Object.keys(this.$store.state.otherUserPageLocks[lockId]).join(', ');
                } else {
                    return "";
                }
            },
            showNewObjectDialog() {
                this.mutableFields.forEach(fieldName => {
                    this.newObject[fieldName] = '';
                });
                this.createPromptActive = true;
                var refs = this.$refs;
                setTimeout(() => this.$nextTick(() => refs.newObjectFirstField.$el.focus()), 300);
            },
            createObject() {
                this.createPromptActive = false;
                this.$store.api.rpcRequest('createLocation', {
                    name: this.newObject.name,
                    abbreviation: this.newObject.abbreviation,
                    cityId: this.$store.state.currentCity.versionedId.id,
                    capacity: this.newObject.capacity,
                    type: "ROOM"
                }, newObject => {
                }, errorMessage => {
                });
            },
            editObject(object) {
                if (!object.edit) {
                    var oldObject = Object.assign({}, object);
                    object.oldObject = oldObject;
                    object.edit = true;
                    this.changed = true;
                    this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
                }
            },
            cancelEditObject(object) {
                if (object.edit) {
                    this.mutableFields.forEach(fieldName => {
                        object[fieldName] = object.oldObject[fieldName];
                    });
                    object.edit = false;
                    this.changed = true;
                    this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
                }
            },
            saveObject(object) {
                if (object.edit) {
                    this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
                    object.edit = false;
                    object.saving = true;
                    this.changed = true;
                    this.$store.api.rpcRequest('saveLocation', {
                        versionedId: object.versionedId,
                        name: object.name,
                        abbreviation: object.abbreviation,
                        enabled: object.enabled,
                        capacity: object.capacity
                    }, savedObject => {
                        object.saving = false;
                    }, errorMessage => {
                        object.edit = true;
                        object.saving = false;
                        this.changed = true;
                        this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
                    });
                }
            },
            askToDelete(object) {
                this.objectToDelete = object;
                this.deletePromptActive = true;
            },
            confirmDelete() {
                this.deleteObject(this.objectToDelete);
            },
            deleteObject(object) {
                if (object.edit) {
                    this.$store.api.softUnlock(this.$route.fullPath, object.versionedId.id);
                    object.edit = false;
                    object.saving = true;
                    this.changed = true;
                    this.$store.api.rpcRequest('deleteLocation', {
                        versionedId: object.versionedId
                    }, savedObject => {
                        object.saving = false;
                    }, errorMessage => {
                        object.edit = true;
                        object.saving = false;
                        this.changed = true;
                        this.$store.api.softLock(this.$route.fullPath, object.versionedId.id);
                    });
                }
            }
        }
    }
</script>

<style scoped>
  .dialogContent {
    padding: 24px;
  }

  .md-table-head {
    text-align: center;
  }

  button.editButton { visibility: hidden;}
  tr:hover button.editButton{ visibility: visible;}

</style>



// WEBPACK FOOTER //
// src/components/city/Locations.vue